
import React from 'react';
import { withStyles, Grid, withRouter } from '../../material-ui';
import MBack from '../view/MBack';
import { MatchLeagueItemHot } from './view';
import Apis from '../../network/Apis';
import AppUtils from '../../control/apputlis';

class MatchCountry extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            competitions: [],
            tabs: [],
        };
        console.log('MatchCountry', props);
    }

    componentDidMount() {
        const { typeId, Id, countryId } = this.props.match.params;
        this.getAreaCompetitionCountry(typeId, Id, countryId);
        AppUtils.YMPush('MAIN', 'MatchCountry');
    }

    componentWillUnmount() {
        this.setState = () => false;
    }


    getAreaCompetitionCountry = async (type_id, category_id, country_id) => {
        let result = await Apis.encryptionAddressComList(type_id, category_id, country_id);
        console.log('getAreaCompetitionCountry', result);
        if (result.code == 200) {
            let data = [];
            for (let i = 0; i < result.data.length; i++) {
                data.push({
                    competition_id: result.data[i].id,
                    short_name_zh: result.data[i].name,
                    type_id: type_id,
                    logo: result.data[i].logo,
                    name: result.data[i].name,
                });
            }
            this.setState({ competitions: data });
        }
    }

    render() {
        const { classes } = this.props;
        const { competitions } = this.state;
        return (
            <MBack title={'地区赛事'}>
                <Grid container direction='row' spacing={1} className={classes.root}>
                    {
                        competitions.map((item, i) => (
                            <Grid key={i} item xs={3} className={classes.gridlist}>
                                <MatchLeagueItemHot data={item} />
                            </Grid>
                        ))
                    }
                </Grid>
            </MBack>
        );
    }

}

export default withRouter(withStyles((theme) => ({
    root: {
        padding: theme.spacing(2, 1, 1, 1)
    },
    gridlist: {
        padding: theme.spacing(0, 0.5, 0, 0.5)
    },

}))(MatchCountry));